import {
  addAccountAccessPath,
  assignableAccountsPath,
  removeAccountAccessPath,
  restoreAccountAccessPath,
} from '../../shared/paths';

const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

const failureFrom = async (response) => {
  try {
    const { errors, terminal } = await response.json();

    return errors && Object.keys(errors).length
      ? { errors, terminal: Boolean(terminal) }
      : null;
  } catch (error) {
    return null;
  }
};

const post = async (path, body) => {
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const failure = await failureFrom(response);

    if (failure) {
      return failure;
    }

    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const { accountAccess } = await response.json();

  return { accountAccess };
};

export const removeAccountAccess = (userId, accountId) =>
  post(removeAccountAccessPath(userId), { account_id: accountId });

export const restoreAccountAccess = (userId, accountId) =>
  post(restoreAccountAccessPath(userId), { account_id: accountId });

export const addAccountAccess = (userId, accountIds) =>
  post(addAccountAccessPath(userId), { account_ids: accountIds });

export const fetchAssignableAccounts = async (userId, query, offset = 0) => {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  if (offset) params.set('offset', String(offset));

  const suffix = params.toString() ? `?${params}` : '';
  const response = await fetch(
    `${assignableAccountsPath(userId)}.json${suffix}`,
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();

  return {
    accounts: data.accounts || [],
    total:
      typeof data.total === 'number'
        ? data.total
        : (data.accounts || []).length,
  };
};
